import Grid2 from "@mui/material/Grid2";
import { Tooltip, Typography } from "components";
import PieChart from "components/Highcharts/PieChart";

interface PieChartSectionProps {
  pieData: any;
  pieClickData: any;
  pieHoverData: any;
  setPieClickData: any;
  setPieHoverData: any;
  pieRef: any;
}

const PieChartSection = (props: PieChartSectionProps) => {
  const {
    pieData,
    pieClickData,
    pieHoverData,
    setPieClickData,
    setPieHoverData,
    pieRef,
  } = props;

  return (
    <Grid2 container>
      <Grid2
        size={7}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <PieChart
          data={pieData}
          pieClickData={pieClickData}
          onClick={setPieClickData}
          onHover={setPieHoverData}
        />
      </Grid2>
      <Grid2 size={5}>
        <Typography
          display={"flex"}
          justifyContent={"center"}
          fontWeight={500}
          color={"var(--black)"}
          fontSize={16}
        >
          Sector-wise Distribution
        </Typography>
        <div
          style={{
            maxHeight: 300,
            overflow: "auto",
            marginTop: "10px",
          }}
        >
          {pieData?.map((legends: any) => (
            <Grid2
              container
              key={legends.id}
              alignItems="center"
              justifyContent="space-between"
              style={{
                fontWeight: "600",
                borderRadius: "4px",
                backgroundColor:
                  pieClickData && pieClickData?.id === legends.id
                    ? "var(--neutral-100)"
                    : "transparent",
                color:
                  pieHoverData?.id === legends.id
                    ? "var(--primary-500)"
                    : "var(--neutral-500)",
              }}
            >
              <Grid2
                size={9}
                container
                alignItems="center"
                style={{ padding: "4px" }}
              >
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    backgroundColor: legends.color,
                    marginRight: "8px",
                  }}
                />
                <Tooltip title={legends.id} arrow placement="top">
                  <Typography
                    display={"flex"}
                    fontSize={12}
                    fontWeight={600}
                    textOverflow={"ellipsis"}
                    whiteSpace={"nowrap"}
                    width={"70%"}
                    overflow={"hidden"}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => setPieClickData(legends)}
                    ref={pieHoverData?.id === legends?.id ? pieRef : undefined}
                  >
                    {legends.id}
                  </Typography>
                </Tooltip>
              </Grid2>
              <Grid2 size={3} pl={1}>
                <Typography
                  fontSize={12}
                  fontWeight={600}
                  color={"var(--black)"}
                >
                  {legends?.value?.toFixed(2)}%
                </Typography>
              </Grid2>
            </Grid2>
          ))}
        </div>
      </Grid2>
    </Grid2>
  );
};

export default PieChartSection;
